export default {
  path: '/sp',
  component: () => import('@/components/sp/entry/layout.vue'),
  meta: {
    bodyClass: ''
  },
  children: [
    {
      path: '/sp/',
      component: () => import('@/components/sp/entry/form.vue'),
      name: 'form_sp',
      meta: {
        bodyClass: '',
        title: '申し込みフォーム'
      }
    },
    {
      path: '/sp/confirmation',
      component: () => import('@/components/sp/entry/confirmation.vue'),
      name: 'confirmation_sp',
      meta: {
        bodyClass: '',
        title: '申し込みフォーム'
      }
    },
    {
      path: '/sp/complete',
      component: () => import('@/components/sp/entry/complete.vue'),
      name: 'complete_sp',
      meta: {
        bodyClass: '',
        title: '申し込みフォーム'
      }
    }
  ]
}
